import Vue from "vue";
// Use it to import all Vue file containing this folder as Components
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component("home", require("./home").default);
Vue.component("report", require("./report").default);
Vue.component("status", require("./status").default);
Vue.component("user", require("./user").default);
Vue.component("export", require("./export").default);
Vue.component("game", require("./game").default);
Vue.component("event", require("./event").default);
Vue.component("school-area", require("./school-area").default);
Vue.component("school", require("./school").default);
Vue.component("notice", require("./notice").default);
Vue.component("mail-history", require("./mail-history").default);
Vue.component("mail", require("./mail").default);
Vue.component("game-info", require("./game-info").default);
Vue.component("entry", require("./entry").default);
Vue.component("tournament", require("./tournament").default);
Vue.component("player", require("./player").default);
Vue.component("rank", require("./rank").default);
Vue.component("staff", require("./staff").default);

Vue.component("login", require("./account/login").default);
Vue.component("register", require("./account/register").default);
Vue.component("forgot-password", require("./account/forgot-password").default);
Vue.component("reset-password", require("./account/reset-password").default);

Vue.component("pages-404", require("./utility/404").default);
Vue.component("pages-500", require("./utility/500").default);
